// 動物主題常量配置
export const ANIMALS = {
  rabbit: {
    id: "rabbit",
    name: "小兔子",
    emoji: "🐰",
    color: "#FFB6C1",
    bgColor: "#FFF0F5",
    item: "胡蘿蔔",
    itemEmoji: "🥕",
  },
  bear: {
    id: "bear",
    name: "小熊",
    emoji: "🐻",
    color: "#DEB887",
    bgColor: "#FFF8DC",
    item: "蜂蜜",
    itemEmoji: "🍯",
  },
  frog: {
    id: "frog",
    name: "小青蛙",
    emoji: "🐸",
    color: "#90EE90",
    bgColor: "#F0FFF0",
    item: "蓮葉",
    itemEmoji: "🍃",
  },
  cat: {
    id: "cat",
    name: "小貓咪",
    emoji: "🐱",
    color: "#FFD700",
    bgColor: "#FFFACD",
    item: "小魚",
    itemEmoji: "🐟",
  },
  dog: {
    id: "dog",
    name: "小狗狗",
    emoji: "🐶",
    color: "#F4A460",
    bgColor: "#FFF5EE",
    item: "骨頭",
    itemEmoji: "🦴",
  },
  panda: {
    id: "panda",
    name: "大熊貓",
    emoji: "🐼",
    color: "#2F4F4F",
    bgColor: "#F5F5F5",
    item: "竹子",
    itemEmoji: "🎋",
  },
  penguin: {
    id: "penguin",
    name: "小企鵝",
    emoji: "🐧",
    color: "#4169E1",
    bgColor: "#E6F3FF",
    item: "冰塊",
    itemEmoji: "🧊",
  },
  monkey: {
    id: "monkey",
    name: "小猴子",
    emoji: "🐵",
    color: "#CD853F",
    bgColor: "#FFEFD5",
    item: "香蕉",
    itemEmoji: "🍌",
  },
  elephant: {
    id: "elephant",
    name: "小象",
    emoji: "🐘",
    color: "#708090",
    bgColor: "#F0F8FF",
    item: "花生",
    itemEmoji: "🥜",
  },
  owl: {
    id: "owl",
    name: "貓頭鷹",
    emoji: "🦉",
    color: "#8B4513",
    bgColor: "#FAF0E6",
    item: "星星",
    itemEmoji: "⭐",
  },
};

// 動物列表
export const ANIMAL_LIST = Object.values(ANIMALS);

// 根據遊戲類型獲取默認動物
export const DEFAULT_ANIMALS = {
  decomposition: "rabbit", // 20內分解遊戲
  placeValue: "bear", // 算柱十進位遊戲
  multiples: "frog", // 倍數遊戲
};

// 隨機獲取動物
export const getRandomAnimal = () => {
  const animals = ANIMAL_LIST;
  return animals[Math.floor(Math.random() * animals.length)];
};

// 獲取動物圖標數組
export const getAnimalIcons = (animal, count) => {
  return Array(count).fill(animal.emoji);
};
